// 緊急お知らせ（下層ページ）表示判定。head 内で定義される
// HAS_IMPORTANT_NOTICE / IMPORTANT_NOTICE_ID を参照するため、</body> 直前で読み込むこと。
(function () {
  "use strict";

  // スヌーズ（リンククリック後の一定時間非表示）用
  var LS_KEY = "uccMuseumImportantNoticeDismiss";
  var DISMISS_MS = 3600000; // 1時間

  /** head 内インライン script のグローバル変数 HAS_IMPORTANT_NOTICE を安全に読む */
  function readHasNotice() {
    return typeof HAS_IMPORTANT_NOTICE !== "undefined" && HAS_IMPORTANT_NOTICE === true;
  }

  /** head 内インライン script のグローバル変数 IMPORTANT_NOTICE_ID を安全に読む */
  function readNoticeId() {
    return typeof IMPORTANT_NOTICE_ID !== "undefined" && IMPORTANT_NOTICE_ID != null
      ? String(IMPORTANT_NOTICE_ID)
      : "";
  }

  /** @param {string} noticeId */
  function isSnoozed(noticeId) {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return false;
      var parsed = JSON.parse(raw);
      if (
        !parsed ||
        typeof parsed !== "object" ||
        typeof parsed.noticeId !== "string" ||
        typeof parsed.hiddenUntil !== "number"
      ) {
        return false;
      }
      if (parsed.noticeId !== noticeId) return false;
      return Date.now() < parsed.hiddenUntil;
    } catch (e) {
      return false;
    }
  }

  /** @param {string} noticeId */
  function recordDismiss(noticeId) {
    try {
      localStorage.setItem(
        LS_KEY,
        JSON.stringify({
          noticeId: noticeId,
          hiddenUntil: Date.now() + DISMISS_MS,
        }),
      );
    } catch (e) {
      /* private mode 等 */
    }
  }

  function init() {
    var main = document.querySelector("main.l-main");
    var page = (main && main.dataset.page) || "";

    // TOP ページは全文バナーを別途表示するため対象外
    if (page === "top") return;

    // 緊急お知らせが無ければ何もしない
    if (!readHasNotice()) return;

    var root = document.getElementById("js-important-notice-subpage");
    if (!root) return;

    var noticeId = readNoticeId();

    // スヌーズ中は表示しない
    if (noticeId && isSnoozed(noticeId)) return;

    root.hidden = false;

    var link = root.querySelector("#js-important-notice-subpage-link");
    if (link && noticeId) {
      link.addEventListener("click", function () {
        recordDismiss(noticeId);
      });
    }
  }

  // defer で読み込まれる想定だが、念のため readyState で分岐
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
